import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useAssistant } from '../../AssistantProvider';

export const HistoryClearedMessage = () => {
  const {
    messages,
    historyCleared,
  } = useAssistant();

  return (
    (historyCleared && messages.length === 1)
      ? (
        <div className="sui-mb-6">
          <Typography align="center" color="subtle" variant="body-base">Conversation cleared</Typography>
        </div>
      )
      : null
  );
};
